import { api_base_url, request } from '../utils';

const BASE = (api_base_url || '').replace(/\/+$/, '');

export class ContactService {
  static ENDPOINT = `${BASE}/contact`;

  static async create(contactCreate, auth = false) {
    return await request({
      url: auth ? `${this.ENDPOINT}/admin` : `${this.ENDPOINT}/`,
      method: 'POST',
      body: contactCreate,
      auth
    })
  }

  static async getAll({ page = 1, pageSize = 15, filter = null, sort = null, roles = null, ignore = false } = {}) {
    const params = new URLSearchParams();
    params.set('page', String(page));
    params.set('pageSize', String(pageSize));
    if (filter != null) params.set('filter', filter);
    if (roles != null) {
      const rolesArray = Array.isArray(roles) ? roles : [roles];
      rolesArray.forEach(role => params.append('rolesName', role));
    }    
    if (ignore) params.set('rolesIgnore', true)
    if (sort != null) {
      if (sort.column) params.set('sortBy', sort.column);
      if (sort.direction) params.set('direction', sort.direction);
    }    
    const qs = params.toString();
    return await request({
      url: `${this.ENDPOINT}/` + (qs ? `?${qs}` : ''),
      headers: {'Accept': 'application/json'}
    })
  }

  static async get(id) {
    return await request({
      url: `${this.ENDPOINT}/${encodeURIComponent(id)}`,
      headers: {'Accept': 'application/json'}
    })
  }

  static async update(id, contactUpdate) {
    return await request({
      url: `${this.ENDPOINT}/${encodeURIComponent(id)}`,
      method: 'PUT',
      body: contactUpdate
    })
  }

  static async delete(id) {
    return await request({
      url: `${this.ENDPOINT}/${encodeURIComponent(id)}`,
      method: 'DELETE'
    })
  }

  static async getCount() {
    return await request({
      url: `${this.ENDPOINT}/count/`,
      headers: {'Accept': 'application/json'}
    })
  }
}

export default ContactService;
